(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name home.directive:loadOnScroll
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="home">
     <file name="index.html">
     <load-on-scroll></load-on-scroll>
     </file>
     </example>
     *
     */
    angular
        .module('commons')
        .directive('loadOnScroll', loadOnScroll);

    function loadOnScroll($compile, $timeout, EventManagerService) {
        return {
            restrict: 'A',
            scope: {
                elementHeight: '@',
                dummySelector: '@',
                numberOfRecordsPerPage: '=',
                numberOfBufferRecords: '@',
                totalNumberOfRecords: '@',
                loadOnScroll: '&',
                syncScrollSelector: '@' // Optional othere elements that should sync with scrollTop value
            },
            replace: false,
            link: function (scope, element) {
                var lastScrollTop = 0,
                    lastUpdateScrollTop = 0,
                    halfBufferHeight = scope.numberOfBufferRecords / 2 * scope.elementHeight,
                    scrollTop = 0,
                    nextIndex = 0,
                    dummyElement = null,
                    nameSection = null,
                    targetElement = null;

                scope.paddingVal = 0;
                targetElement = angular.element(element)[0];

                EventManagerService.registerEventListener(EventManagerService.EVENT.RESET_SCROLL_TOP, onScrollTopReset);

                if (angular.isUndefined(scope.numberOfBufferRecords)) {
                    scope.numberOfBufferRecords = 1;
                }

               /*  if (angular.isDefined(scope.syncScrollSelector)) {
                 nameSection = angular.element(scope.syncScrollSelector);
                 element.on('scroll', function (d) {
                    scrollTop = targetElement.scrollTop;
                 // nameSection.scrollTop(targetElement.scrollTop);
                 });
                 }*/

                if (angular.isUndefined(scope.dummySelector)) {
                    var template = $compile('<div class="dummy " ng-style="{\'padding-top\':paddingVal+\'px\'}"></div>')(scope);
                    angular.element(element).prepend(template);
                    dummyElement = null;
                } else {
                    dummyElement = angular.element(scope.dummySelector);
                }

                function onScrollTopReset(data) {
                    if (!!data) {
                        scope.paddingVal = data * scope.elementHeight;
                        if (!!dummyElement) {
                            dummyElement.css('padding-bottom', scope.paddingVal + 'px');
                        }
                        lastScrollTop = scope.paddingVal;
                        lastUpdateScrollTop = lastScrollTop;
                        angular.element(element).scrollTop(lastScrollTop);
                    } else {
                        scrollTop = 0;
                        lastUpdateScrollTop = 0;
                        angular.element(element).scrollTop(0);
                        if (!!dummyElement) {
                            dummyElement.css('padding-bottom', 0 + 'px');
                        }
                    }
                }

                function invokeCallback(records) {
                    scope.$apply(function () {
                        scope.loadOnScroll({
                            scrollParam: {
                                nextIndex: records
                            }
                        });
                    });
                }


                element.on('scroll', _.debounce(function () {
                    scrollTop = targetElement.scrollTop;
                    if ((scrollTop > lastScrollTop) &&
                        ( scrollTop - lastUpdateScrollTop >= halfBufferHeight)) {
                        nextIndex = Math.ceil(scrollTop / scope.elementHeight) - scope.numberOfBufferRecords;
                        if (nextIndex > 0 ) {
                            if (nextIndex > (scope.totalNumberOfRecords - scope.numberOfRecordsPerPage)) {
                                nextIndex = scope.totalNumberOfRecords - scope.numberOfRecordsPerPage
                            }
                            scope.paddingVal = nextIndex * scope.elementHeight;
                            if (!!dummyElement) {
                                dummyElement.css('padding-bottom', scope.paddingVal + 'px');
                            }
                            lastUpdateScrollTop = scrollTop;
                            invokeCallback(nextIndex);
                        }
                    } else if (scrollTop < lastScrollTop && ( lastUpdateScrollTop - scrollTop >= halfBufferHeight)) {
                        nextIndex = Math.floor((scrollTop - (scope.numberOfBufferRecords * scope.elementHeight) ) / scope.elementHeight);
                        if (nextIndex < 0) {
                            nextIndex = 0;
                        }

                        if (nextIndex < scope.totalNumberOfRecords - scope.numberOfRecordsPerPage) {
                            scope.paddingVal = nextIndex * scope.elementHeight;
                            if (!!dummyElement) {
                                dummyElement.css('padding-bottom', scope.paddingVal + 'px');
                            }
                            lastUpdateScrollTop = scrollTop;
                            invokeCallback(nextIndex);
                        }
                    }
                    lastScrollTop = scrollTop;
                }, 300));
            }
        };
    }
}());
